import { render, staticRenderFns } from "./ContrattoSperimentazione.vue?vue&type=template&id=3dd60a06&"
import script from "./ContrattoSperimentazione.vue?vue&type=script&lang=js&"
export * from "./ContrattoSperimentazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports